import script from "./RelatorioPreviewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RelatorioPreviewModal.vue?vue&type=script&setup=true&lang=js"

import "./RelatorioPreviewModal.vue?vue&type=style&index=0&id=20d92680&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20d92680"]])

export default __exports__